import { NgxLoggerLevel } from 'ngx-logger';
import { AppEnvironment, commonEnvironment } from './environment.common';

const clientId = '7q9tr4a9nh882iaqju6t3om6sm'; //Cognito
const redirectUrl = 'https://demo.mybenefits-int.symetra.com/authorize';
const loginOrigin = 'https://demo.mybenefits-int.symetra.com/login';
const appBaseUrl = 'https://demo.mybenefits-int.symetra.com';
const profileSettingsUrl = 'https://profile.qa.symetra.com/webcontent/common/UpdateProfile/ChangePassword.aspx';
const partnerPortalUrl = 'https://login.partnerportal.dcx.int.symetra.com';
const claimDetailPolicyHolderCTAUrl = 'https://symetralams--demo.sandbox.my.site.com/portal';

export const environment: AppEnvironment = {
  ...commonEnvironment,
  pageTitleSuffix: 'My Benefits at Symetra (DEMO)',
  clientId,
  loginUrl: `https://bdportal-demo.auth.us-west-2.amazoncognito.com/authorize?client_id=${clientId}&response_type=code&scope=email+openid+profile&redirect_uri=${redirectUrl}&identity_provider=NET-IQ`, //Cognito
  redirectUrl,
  profileSettingsUrl,
  partnerPortalUrl,
  loginOrigin,
  appBaseUrl,
  claimDetailPolicyHolderCTAUrl,

  serverTelemetryLevel: NgxLoggerLevel.DEBUG
};
